import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'caseGroupCreationCptcodesPipe',
  pure: true
})
export class CaseGroupCreationCptcodesPipePipe implements PipeTransform {

  transform(codesData: any[], searchTermcpt: string): any[]  {
    if (!codesData || !searchTermcpt) { return codesData; }

    // codesData.forEach(element => {
    //   if(element.Desc==null ){
    //     element.Desc="";
    //   }
    
    // });
    return codesData.filter(ad =>
     
    
      ad.name.toLowerCase().indexOf(searchTermcpt.toLowerCase().trim()) !== -1
     ||

     ad.desc.toLowerCase().indexOf(searchTermcpt.toLowerCase().trim()) !== -1


    );
  }

}
